// import React, { useEffect, useState } from "react";
// import { FaShoppingCart, FaHeart, FaUser } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import Api from "../Utills/Api";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import logo from "../../Frozenwala.png";

// import {
//   Navbar as BsNavbar,
//   Nav,
//   Container,
//   Button
// } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { useWishlist } from "../../contexts/WishlistContext";

// function NavbarComponent({ refreshCart, isCollapsedTop, fixedTop = false }) {
//   const { wishlist } = useWishlist();
//   const navigate = useNavigate();
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [cartValue, setCartValue] = useState(0);
//   const [name, setName] = useState("");
//   const [expanded, setExpanded] = useState(false);

//   // Get user profile
//   useEffect(() => {
//     const fetchProfile = async () => {
//       const userId = localStorage.getItem("user_id");
//       if (!userId) return setIsLoggedIn(false);

//       try {
//         const response = await Api.get(`api/profile/?user_id=${userId}`);
//         setName(response.data.name);
//         setIsLoggedIn(true);
//       } catch (error) {
//         console.log("Error fetching profile:", error);
//         if (error?.status === 401){
//           localStorage.removeItem("user_id");
//           localStorage.removeItem("access_token");
//           localStorage.removeItem("referral_code");
//           localStorage.removeItem("name");
//           localStorage.removeItem("wallet");
//           setIsLoggedIn(false);
//         }
//       }
//     };
//     fetchProfile();
//   }, []);

//   // Cart count
//   const getCartNumber = async () => {
//     const uid = localStorage.getItem("user_id");
//     if (!uid) return;
//     try {
//       const response = await Api.get(`api/unique-product-count/?user_id=${uid}`);
//       setCartValue(parseInt(response.data.unique_product_count));
//     } catch (error) {
//       console.error("Error fetching cart value:", error);
//     }
//   };

//   useEffect(() => {
//     getCartNumber();
//   }, [refreshCart]);

//   // Profile/Login
//   const handleClick = () => {
//     setExpanded(false);
//     navigate(isLoggedIn ? "/profile" : "/login");
//   };

//   // Cart
//   const handleClickCart = () => {
//     setExpanded(false);
//     navigate(isLoggedIn ? "/cart" : "/login");
//   };

//   // Determine if navbar should appear in its flat, docked state
//   const isDocked = fixedTop || isCollapsedTop;

//   return (
//     <>
//       <style>{`
//         .custom-floating-navbar {
//           position: fixed !important;
//           top: ${fixedTop ? "0px" : "38px"} !important; 
//           left: 50% !important;
//           transform: translateX(-50%) !important;
//           width: ${fixedTop ? "100%" : "calc(100% - 48px)"} !important;
//           max-width: ${fixedTop ? "100%" : "1400px"} !important; 
          
//           background: ${fixedTop ? "rgba(255, 255, 255, 0.85)" : "rgba(255, 255, 255, 0.45)"} !important; 
//           backdrop-filter: blur(25px) saturate(140%) brightness(1.02) !important;
//           -webkit-backdrop-filter: blur(25px) saturate(140%) brightness(1.02) !important;
//           border: ${fixedTop ? "none" : "1px solid rgba(255, 255, 255, 0.4)"} !important; 
//           border-bottom: ${fixedTop ? "1px solid rgba(0, 0, 0, 0.08)" : "none"} !important;
//           border-radius: ${fixedTop ? "0px" : "20px"} !important;
          
//           box-shadow: ${fixedTop ? "0 4px 20px rgba(0, 0, 0, 0.08)" : "0 15px 35px -5px rgba(0, 0, 0, 0.18), 0 10px 15px -5px rgba(0, 0, 0, 0.1)"} !important;
//           z-index: 1030 !important;
//           transition: top 0.4s cubic-bezier(0.16, 1, 0.3, 1), 
//                       width 0.4s cubic-bezier(0.16, 1, 0.3, 1), 
//                       border-radius 0.4s cubic-bezier(0.16, 1, 0.3, 1), 
//                       padding 0.4s cubic-bezier(0.16, 1, 0.3, 1), 
//                       background 0.4s ease !important;
//           padding: ${fixedTop ? "10px 24px" : "14px 24px"} !important; 
//         }

//         /* Continuous Scroll Class Docking on Home Page */
//         .custom-floating-navbar.scrolled-top-dock {
//           top: 0px !important;
//           width: 100% !important;
//           max-width: 100% !important;
//           border-radius: 0px !important;
//           border-left: none !important;
//           border-right: none !important;
//           border-top: none !important;
//           background: rgba(255, 255, 255, 0.85) !important;
//           box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
//           padding: 10px 24px !important;
//           border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
//         }

//         .premium-circle-icon {
//           width: 44px;
//           height: 44px;
//           border-radius: 50%;
//           background: rgba(255, 245, 240, 0.8) !important; 
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           transition: all 0.25s ease, transform 0.2s ease;
//           border: 1px solid rgba(255, 228, 214, 0.6);
//           box-shadow: 0 3px 8px rgba(241, 114, 40, 0.12);
//         }

//         .premium-circle-icon:hover {
//           background: #5dc5fa !important;
//           transform: scale(1.08) translateY(-2px);
//           border-color: #5dc5fa;
//           box-shadow: 0 6px 16px rgba(241, 114, 40, 0.3);
//         }
        
//         .premium-circle-icon:hover svg {
//           color: #ffffff !important;
//         }

//         .three-dots-toggle .navbar-toggler-icon {
//           display: none !important;
//         }
        
//         .three-dots-toggle {
//           padding: 0px !important;
//           background: #fff5f0 !important;
//           font-weight: bold;
//           font-size: 1.4rem;
//           line-height: 1;
//           display: flex !important;
//           align-items: center;
//           justify-content: center;
//           border-radius: 50% !important;
//           width: 36px;
//           height: 36px;
//           border: none !important;
//           flex-shrink: 0;
//         }

//         .three-dots-toggle::before {
//           content: "\\22EE"; 
//           color: #5dc5fa;
//         }

//         /* HARD OVERRIDE TO FORCE ONE ROW AT ALL TIMES ON THIN PHONES */
//         .forced-single-row-container {
//           display: flex !important;
//           flex-direction: row !important;
//           flex-wrap: nowrap !important;
//           justify-content: space-between !important;
//           align-items: center !important;
//           width: 100% !important;
//         }

//         @media (max-width: 991.98px) {
//           .custom-floating-navbar {
//             top: ${fixedTop ? "0px" : "15px"} !important;
//             width: ${fixedTop ? "100%" : "calc(100% - 30px)"} !important;
//             border-radius: ${fixedTop ? "0px" : "16px"} !important;
//             padding: 8px 12px !important;
//             left: 50% !important;
//             transform: translateX(-50%) !important;
//             max-width: 100% !important;
//           }

//           .custom-floating-navbar.scrolled-top-dock {
//             top: 0px !important;
//             width: 100% !important;
//             border-radius: 0px !important;
//             padding: 8px 12px !important;
//             left: 0px !important;
//             transform: none !important;
//           }
          
//           .collapsed-nav-fix {
//             position: absolute !important;
//             right: 0px !important; 
//             top: 50px !important; 
//             background: #ffffff !important;
//             border: 1px solid rgba(0, 0, 0, 0.08) !important;
//             border-radius: 18px !important;
//             box-shadow: 0 10px 30px rgba(0,0,0,0.15) !important;
//             width: 220px !important;
//             padding: 8px 0 !important;
//             z-index: 2000 !important;
//             overflow: hidden !important;
//           }

//           .nav-buttons-container {
//             display: flex !important;
//             flex-direction: column !important;
//             align-items: stretch !important; 
//             justify-content: flex-start !important;
//             gap: 0px !important;
//             margin-top: 0px !important;
//             width: 100% !important;
//           }

//           .nav-buttons-container .profile-btn,
//           .nav-buttons-container .premium-circle-icon {
//             width: 100% !important;
//             height: auto !important;
//             border-radius: 0px !important;
//             background: transparent !important;
//             border: none !important;
//             box-shadow: none !important;
//             padding: 12px 20px !important;
//             display: flex !important;
//             align-items: center !important;
//             justify-content: flex-start !important;
//             gap: 14px !important;
//             transition: background 0.2s ease !important;
//           }

//           .nav-buttons-container .profile-btn:hover,
//           .nav-buttons-container .premium-circle-icon:hover {
//             background: rgba(241, 114, 40, 0.06) !important;
//             transform: none !important;
//           }

//           .nav-buttons-container .premium-circle-icon button {
//             padding: 0 !important;
//             background: transparent !important;
//             border: none !important;
//             box-shadow: none !important;
//             display: flex !important;
//             align-items: center !important;
//             justify-content: flex-start !important;
//             gap: 14px !important;
//             width: 100% !important;
//             font-weight: 700 !important;
//             font-size: 0.95rem !important;
//             color: #212529 !important;
//           }

//           .nav-buttons-container .premium-circle-icon button::after {
//             display: none !important;
//           }

//           .nav-buttons-container .badge {
//             position: static !important;
//             transform: none !important;
//             margin-left: auto !important;
//             margin-top: 0 !important;
//           }
          
//           .mobile-nav-label {
//             display: inline-block !important;
//             font-weight: 700 !important;
//             font-size: 0.95rem !important;
//             color: #212529 !important;
//           }
//         }
//       `}</style>

//       <BsNavbar
//         expand="lg"
//         expanded={expanded}
//         onToggle={(isExpanded) => setExpanded(isExpanded)}
//         className={`custom-floating-navbar ${isDocked && !fixedTop ? 'scrolled-top-dock' : ''}`}
//       >
//         <Container fluid className="px-0 forced-single-row-container">
//           <BsNavbar.Brand
//             onClick={() => {
//               navigate("/");
//               setExpanded(false);
//             }}
//             className="d-flex align-items-center cursor-pointer flex-nowrap me-auto"
//             style={{ cursor: "pointer", gap: "6px", minWidth: 0, padding: 0 }}
//           >
//             <img
//               src={logo}
//               alt="logo"
//               style={{ height: "30px", width: "70px", objectFit: "contain", flexShrink: 0 }}
//               className="d-inline-block"
//             />
//             <span style={{ 
//               fontSize: "clamp(0.75rem, 3.2vw, 1.25rem)", 
//               fontWeight: "900", 
//               fontFamily: "Playwrite US Trad Guides, cursive", 
//               color: "#5dc5fa",
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               letterSpacing: "0.1px",
//               textShadow: "1px 1px 0px #ffffff, -1px -1px 0px #ffffff, 1px -1px 0px #ffffff, -1px 1px 0px #ffffff, 0px 4px 12px rgba(241, 114, 40, 0.35)"
//             }}>
//               Are You Hungry?
//             </span>
//           </BsNavbar.Brand>

//           <div className="d-flex align-items-center flex-shrink-0" style={{ paddingLeft: "4px" }}>
//             <div className="d-lg-none">
//               <BsNavbar.Toggle 
//                 aria-controls="navbarSupportedContent" 
//                 className="border-0 three-dots-toggle" 
//               />
//             </div>
            
//             <BsNavbar.Collapse id="navbarSupportedContent" className="collapsed-nav-fix">
//               <Nav className="d-flex align-items-center gap-4 nav-buttons-container">
                
//                 <Button
//                   variant="white"
//                   className="border-0 d-flex align-items-center gap-3 position-relative profile-btn"
//                   onClick={handleClick}
//                   style={{
//                     padding: "8px 24px",
//                     borderRadius: "30px",
//                     background: "rgba(255, 255, 255, 0.8)",
//                     border: "1px solid rgba(203, 213, 225, 0.7)",
//                     boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
//                     transition: "all 0.2s ease"
//                   }}
//                 >
//                   <div style={{ width: "19px", height: "19px", display: "flex", justifyContent: "center", alignItems: "center" }}>
//                     <FaUser size={15} color="#212529" />
//                   </div>
//                   <span style={{ color: "#212529", fontWeight: 700, fontSize: "0.95rem" }}>
//                     {isLoggedIn ? `Hi, ${name.split(" ")[0]}` : "Login"}
//                   </span>
//                 </Button>

//                 <div className="premium-circle-icon" onClick={() => { setExpanded(false); navigate("/wishlist"); }} style={{ cursor: "pointer" }}>
//                   <Button
//                     variant="white"
//                     className="border-0 position-relative p-0 d-flex align-items-center justify-content-start"
//                     style={{ background: "transparent" }}
//                   >
//                     <FaHeart fontSize="19px" color="#5dc5fa" style={{ transition: "color 0.2s", minWidth: "20px" }} />
//                     <span className="mobile-nav-label d-none mx-2">Wishlist</span>
//                     {wishlist && wishlist.length > 0 && (
//                       <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: "0.65rem" }}>
//                         {wishlist.length}
//                       </span>
//                     )}
//                   </Button>
//                 </div>

//                 <div className="premium-circle-icon" onClick={handleClickCart} style={{ cursor: "pointer" }}>
//                   <Button
//                     variant="white"
//                     className="border-0 position-relative p-0 d-flex align-items-center justify-content-start"
//                     style={{ background: "transparent" }}
//                   >
//                     <FaShoppingCart fontSize="19px" color="#5dc5fa" style={{ transition: "color 0.2s", minWidth: "20px" }} />
//                     <span className="mobile-nav-label d-none mx-2">Cart</span>
//                     {cartValue > 0 && (
//                       <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: "0.65rem", padding: "3px 5px" }}>
//                         {cartValue}
//                       </span>
//                     )}
//                   </Button>
//                 </div>

//               </Nav>
//             </BsNavbar.Collapse>
//           </div>
//         </Container>
//       </BsNavbar>
//       <ToastContainer />
//     </>
//   );
// }

// export default NavbarComponent;

import React, { useEffect, useState } from "react";
import { FaShoppingCart, FaHeart, FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Api from "../Utills/Api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../../Frozenwala.png";

import {
  Navbar as BsNavbar,
  Nav,
  Container,
  Button
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useWishlist } from "../../contexts/WishlistContext";

function NavbarComponent({ refreshCart, isCollapsedTop, fixedTop = false }) {
  const { wishlist } = useWishlist();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [cartValue, setCartValue] = useState(0);
  const [name, setName] = useState("");
  const [expanded, setExpanded] = useState(false);

  // Get user profile
  useEffect(() => {
    const fetchProfile = async () => {
      const userId = localStorage.getItem("user_id");
      if (!userId) return setIsLoggedIn(false);

      try {
        const response = await Api.get(`api/profile/?user_id=${userId}`);
        setName(response.data.name);
        setIsLoggedIn(true);
      } catch (error) {
        console.log("Error fetching profile:", error);
        if (error?.status === 401){
          localStorage.removeItem("user_id");
          localStorage.removeItem("access_token");
          localStorage.removeItem("referral_code");
          localStorage.removeItem("name");
          localStorage.removeItem("wallet");
          setIsLoggedIn(false);
        }
      }
    };
    fetchProfile();
  }, []);

  // Cart count
  const getCartNumber = async () => {
    const uid = localStorage.getItem("user_id");
    if (!uid) return;
    try {
      const response = await Api.get(`api/unique-product-count/?user_id=${uid}`);
      setCartValue(parseInt(response.data.unique_product_count));
    } catch (error) {
      console.error("Error fetching cart value:", error);
    }
  };

  useEffect(() => {
    getCartNumber();
  }, [refreshCart]);

  // Profile/Login
  const handleClick = () => {
    setExpanded(false);
    navigate(isLoggedIn ? "/profile" : "/login");
  };

  // Cart
  const handleClickCart = () => {
    setExpanded(false);
    navigate(isLoggedIn ? "/cart" : "/login");
  };

  // Determine if navbar should appear in its flat, docked state
  const isDocked = fixedTop || isCollapsedTop;

  return (
    <>
      <style>{`
        .custom-floating-navbar {
          position: fixed !important;
          top: ${fixedTop ? "0px" : "38px"} !important; 
          left: 50% !important;
          transform: translateX(-50%) !important;
          width: ${fixedTop ? "100%" : "calc(100% - 48px)"} !important;
          max-width: ${fixedTop ? "100%" : "1400px"} !important; 
          
          background: ${fixedTop ? "rgba(255, 255, 255, 0.85)" : "rgba(255, 255, 255, 0.45)"} !important; 
          backdrop-filter: blur(25px) saturate(140%) brightness(1.02) !important;
          -webkit-backdrop-filter: blur(25px) saturate(140%) brightness(1.02) !important;
          border: ${fixedTop ? "none" : "1px solid rgba(255, 255, 255, 0.4)"} !important; 
          border-bottom: ${fixedTop ? "1px solid rgba(0, 0, 0, 0.08)" : "none"} !important;
          border-radius: ${fixedTop ? "0px" : "20px"} !important;
          
          box-shadow: ${fixedTop ? "0 4px 20px rgba(0, 0, 0, 0.08)" : "0 15px 35px -5px rgba(0, 0, 0, 0.18), 0 10px 15px -5px rgba(0, 0, 0, 0.1)"} !important;
          z-index: 1030 !important;
          transition: top 0.4s cubic-bezier(0.16, 1, 0.3, 1), 
                      width 0.4s cubic-bezier(0.16, 1, 0.3, 1), 
                      border-radius 0.4s cubic-bezier(0.16, 1, 0.3, 1), 
                      padding 0.4s cubic-bezier(0.16, 1, 0.3, 1), 
                      background 0.4s ease !important;
          padding: ${fixedTop ? "10px 24px" : "14px 24px"} !important; 
        }

        /* Continuous Scroll Class Docking on Home Page */
        .custom-floating-navbar.scrolled-top-dock {
          top: 0px !important;
          width: 100% !important;
          max-width: 100% !important;
          border-radius: 0px !important;
          border-left: none !important;
          border-right: none !important;
          border-top: none !important;
          background: rgba(255, 255, 255, 0.85) !important;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
          padding: 10px 24px !important;
          border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
        }

        /* Brand (logo + wordmark) sizing/spacing */
        .brand-logo-img {
          height: clamp(32px, 4vw, 54px) !important;
          width: auto !important;
          object-fit: contain !important;
          flex-shrink: 0 !important;
        }

        .brand-wordmark {
          font-size: clamp(0.9rem, 2.4vw, 1.6rem) !important;
        }

        /* On large screens, pull the brand tight to the true left edge of the
           navbar instead of leaving the default 24px inner padding, and let
           the logo grow further since there's room. */
        @media (min-width: 992px) {
          .custom-floating-navbar {
            padding-left: 14px !important;
          }
          .custom-floating-navbar.scrolled-top-dock {
            padding-left: 20px !important;
          }
          .brand-logo-img {
            height: clamp(38px, 3.2vw, 60px) !important;
          }
        }

        .premium-circle-icon {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: rgba(255, 245, 240, 0.8) !important; 
          display: flex;
          justify-content: center;
          align-items: center;
          transition: all 0.25s ease, transform 0.2s ease;
          border: 1px solid rgba(255, 228, 214, 0.6);
          box-shadow: 0 3px 8px rgba(241, 114, 40, 0.12);
        }

        .premium-circle-icon:hover {
          background: #5dc5fa !important;
          transform: scale(1.08) translateY(-2px);
          border-color: #5dc5fa;
          box-shadow: 0 6px 16px rgba(241, 114, 40, 0.3);
        }
        
        .premium-circle-icon:hover svg {
          color: #ffffff !important;
        }

        .three-dots-toggle .navbar-toggler-icon {
          display: none !important;
        }
        
        .three-dots-toggle {
          padding: 0px !important;
          background: #fff5f0 !important;
          font-weight: bold;
          font-size: 1.4rem;
          line-height: 1;
          display: flex !important;
          align-items: center;
          justify-content: center;
          border-radius: 50% !important;
          width: 36px;
          height: 36px;
          border: none !important;
          flex-shrink: 0;
        }

        .three-dots-toggle::before {
          content: "\\22EE"; 
          color: #5dc5fa;
        }

        /* HARD OVERRIDE TO FORCE ONE ROW AT ALL TIMES ON THIN PHONES */
        .forced-single-row-container {
          display: flex !important;
          flex-direction: row !important;
          flex-wrap: nowrap !important;
          justify-content: space-between !important;
          align-items: center !important;
          width: 100% !important;
        }

        @media (max-width: 991.98px) {
          .custom-floating-navbar {
            top: ${fixedTop ? "0px" : "15px"} !important;
            width: ${fixedTop ? "100%" : "calc(100% - 30px)"} !important;
            border-radius: ${fixedTop ? "0px" : "16px"} !important;
            padding: 8px 12px !important;
            left: 50% !important;
            transform: translateX(-50%) !important;
            max-width: 100% !important;
          }

          .custom-floating-navbar.scrolled-top-dock {
            top: 0px !important;
            width: 100% !important;
            border-radius: 0px !important;
            padding: 8px 12px !important;
            left: 0px !important;
            transform: none !important;
          }
          
          .collapsed-nav-fix {
            position: absolute !important;
            right: 0px !important; 
            top: 50px !important; 
            background: #ffffff !important;
            border: 1px solid rgba(0, 0, 0, 0.08) !important;
            border-radius: 18px !important;
            box-shadow: 0 10px 30px rgba(0,0,0,0.15) !important;
            width: 220px !important;
            padding: 8px 0 !important;
            z-index: 2000 !important;
            overflow: hidden !important;
          }

          .nav-buttons-container {
            display: flex !important;
            flex-direction: column !important;
            align-items: stretch !important; 
            justify-content: flex-start !important;
            gap: 0px !important;
            margin-top: 0px !important;
            width: 100% !important;
          }

          .nav-buttons-container .profile-btn,
          .nav-buttons-container .premium-circle-icon {
            width: 100% !important;
            height: auto !important;
            border-radius: 0px !important;
            background: transparent !important;
            border: none !important;
            box-shadow: none !important;
            padding: 12px 20px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: flex-start !important;
            gap: 14px !important;
            transition: background 0.2s ease !important;
          }

          .nav-buttons-container .profile-btn:hover,
          .nav-buttons-container .premium-circle-icon:hover {
            background: rgba(241, 114, 40, 0.06) !important;
            transform: none !important;
          }

          .nav-buttons-container .premium-circle-icon button {
            padding: 0 !important;
            background: transparent !important;
            border: none !important;
            box-shadow: none !important;
            display: flex !important;
            align-items: center !important;
            justify-content: flex-start !important;
            gap: 14px !important;
            width: 100% !important;
            font-weight: 700 !important;
            font-size: 0.95rem !important;
            color: #212529 !important;
          }

          .nav-buttons-container .premium-circle-icon button::after {
            display: none !important;
          }

          .nav-buttons-container .badge {
            position: static !important;
            transform: none !important;
            margin-left: auto !important;
            margin-top: 0 !important;
          }
          
          .mobile-nav-label {
            display: inline-block !important;
            font-weight: 700 !important;
            font-size: 0.95rem !important;
            color: #212529 !important;
          }
        }
      `}</style>

      <BsNavbar
        expand="lg"
        expanded={expanded}
        onToggle={(isExpanded) => setExpanded(isExpanded)}
        className={`custom-floating-navbar ${isDocked && !fixedTop ? 'scrolled-top-dock' : ''}`}
      >
        <Container fluid className="px-0 forced-single-row-container">
          <BsNavbar.Brand
            onClick={() => {
              navigate("/");
              setExpanded(false);
            }}
            className="d-flex align-items-center cursor-pointer flex-nowrap me-auto"
            style={{ cursor: "pointer", gap: "8px", minWidth: 0, padding: 0, marginLeft: 0 }}
          >
            <img
              src={logo}
              alt="logo"
              className="brand-logo-img d-inline-block"
            />
            <span className="brand-wordmark" style={{ 
              fontWeight: "900", 
              fontFamily: "Playwrite US Trad Guides, cursive", 
              color: "#5dc5fa",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              letterSpacing: "0.1px",
              textShadow: "1px 1px 0px #ffffff, -1px -1px 0px #ffffff, 1px -1px 0px #ffffff, -1px 1px 0px #ffffff, 0px 4px 12px rgba(241, 114, 40, 0.35)"
            }}>
              Are You Hungry?
            </span>
          </BsNavbar.Brand>

          <div className="d-flex align-items-center flex-shrink-0" style={{ paddingLeft: "4px" }}>
            <div className="d-lg-none">
              <BsNavbar.Toggle 
                aria-controls="navbarSupportedContent" 
                className="border-0 three-dots-toggle" 
              />
            </div>
            
            <BsNavbar.Collapse id="navbarSupportedContent" className="collapsed-nav-fix">
              <Nav className="d-flex align-items-center gap-4 nav-buttons-container">
                
                <Button
                  variant="white"
                  className="border-0 d-flex align-items-center gap-3 position-relative profile-btn"
                  onClick={handleClick}
                  style={{
                    padding: "8px 24px",
                    borderRadius: "30px",
                    background: "rgba(255, 255, 255, 0.8)",
                    border: "1px solid rgba(203, 213, 225, 0.7)",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                    transition: "all 0.2s ease"
                  }}
                >
                  <div style={{ width: "19px", height: "19px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <FaUser size={15} color="#212529" />
                  </div>
                  <span style={{ color: "#212529", fontWeight: 700, fontSize: "0.95rem" }}>
                    {isLoggedIn ? `Hi, ${name.split(" ")[0]}` : "Login"}
                  </span>
                </Button>

                <div className="premium-circle-icon" onClick={() => { setExpanded(false); navigate("/wishlist"); }} style={{ cursor: "pointer" }}>
                  <Button
                    variant="white"
                    className="border-0 position-relative p-0 d-flex align-items-center justify-content-start"
                    style={{ background: "transparent" }}
                  >
                    <FaHeart fontSize="19px" color="#5dc5fa" style={{ transition: "color 0.2s", minWidth: "20px" }} />
                    <span className="mobile-nav-label d-none mx-2">Wishlist</span>
                    {wishlist && wishlist.length > 0 && (
                      <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: "0.65rem" }}>
                        {wishlist.length}
                      </span>
                    )}
                  </Button>
                </div>

                <div className="premium-circle-icon" onClick={handleClickCart} style={{ cursor: "pointer" }}>
                  <Button
                    variant="white"
                    className="border-0 position-relative p-0 d-flex align-items-center justify-content-start"
                    style={{ background: "transparent" }}
                  >
                    <FaShoppingCart fontSize="19px" color="#5dc5fa" style={{ transition: "color 0.2s", minWidth: "20px" }} />
                    <span className="mobile-nav-label d-none mx-2">Cart</span>
                    {cartValue > 0 && (
                      <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: "0.65rem", padding: "3px 5px" }}>
                        {cartValue}
                      </span>
                    )}
                  </Button>
                </div>

              </Nav>
            </BsNavbar.Collapse>
          </div>
        </Container>
      </BsNavbar>
      <ToastContainer />
    </>
  );
}

export default NavbarComponent;